export default {
	state: {
		mapOptions: {
			mapTypeControl: false,
			streetViewControl: false,
			fullscreenControl: true,
			stylers: [],
			styles: [
				{ elementType: "geometry", stylers: [{ saturation: -100 }] },
				{
					featureType: "poi",
					elementType: "labels.text",
					stylers: [
						{
							visibility: "off"
						}
					]
				},
				{
					featureType: "poi.business",
					stylers: [
						{
							visibility: "off"
						}
					]
				},
				{
					featureType: "road",
					elementType: "labels.icon",
					stylers: [
						{
							visibility: "off"
						}
					]
				},
				{
					featureType: "transit",
					stylers: [
						{
							visibility: "off"
						}
					]
				} // ,
				// {
				// 	featureType: "poi.park",
				// 	elementType: "geometry",
				// 	stylers: [{ color: "#263c3f" }]
				// }
			]
		}
	},
	getters: {
		mapOptions: (state: any) => state.mapOptions
	}
};
